
/* Show the menu if you are scrolling up */
function ScrollShowMenu(isDown){
  var menuIsOpen = $('button.site-nav__link.site-nav__link--icon.site-nav__compress-menu').hasClass('is-active');
  var openCount =$(".is-focused>.site-nav__dropdown, .site-nav--has-dropdown:hover .site-nav__dropdown").length; 
  // dont do anything if a menu is open
  if (openCount > 0) {
    //console.log("do nothing");
  } else {
    //console.log("trigger");
    var doAClick = (!menuIsOpen && isDown) || (menuIsOpen && !isDown);
    var isMobile = $(window).innerWidth() <= 768;
    if (doAClick && !isMobile)
      $('button.site-nav__link.site-nav__link--icon.site-nav__compress-menu').click();
  }
}

var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout (timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();


$( window ).on( "load", function() {
  // fix header and promo overlap
	fixHeaderPlim();
	  setTimeout(() => {
	  fixHeaderPlim();
	}, "1000");


	// listen for the header content changing
	MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
	var observer = new MutationObserver(function(mutations, observer) {
		// fired when a mutation occurs
		console.log(mutations, observer);
		// ...
		fixHeaderPlim(true);
		// and AGAIN in a moment, since the X close button doesn't remove content before this runs?
		setTimeout(() => {
			fixHeaderPlim();
		}, "1000");
		
	});
	// define what element should be observed by the observer
	// and what types of mutations trigger the callback
	observer.observe($("#qab_container")[0], {
	  subtree: true,
	  attributes: true
	});
	// listen for window size changing
	$(window).resize(function () {
		waitForFinalEvent(function(){
		  //alert('Resize...');
		  //...
		  fixHeaderPlim();
		}, 500, "resizedelay");
	});

} );

function fixHeaderPlim(onlyifzero = false){
  console.log("header fix");
  //jQuery(".header-section").css("top", jQuery("#qab_container").height()+"px")
  //jQuery(".header-section").css("margin-top", jQuery("#qab_container").height()+"px");  
  var theHeight = jQuery("#qab_background").height();
  if (theHeight == null) theHeight = 0;
  var doTheFix = (!onlyifzero) || (onlyifzero && (theHeight == 0));
  //var theHeightB = jQuery(".collection-filter__inner").height();
  if (doTheFix){
	  jQuery(".header-section").css("padding-top", theHeight+"px");  
	  jQuery(".collection-filter__inner").css("top", (theHeight)+"px");  
	  jQuery(".collection-mobile-filters__holder").css("top", (theHeight)+"px");  
  }
}




$(function() {
  console.log("edits js 6/28/24");

  fixHeaderPlim();
  // put contact information in footer block.
  var showroomHours = `<strong>Showroom Hours:</strong><br/> 
<strong>By Appointment Only</strong><br/>
Mon: 9 AM - 5 PM <br/>
<strong>Walk-Ins Welcome</strong><br/>
Tues - Fri: 9 AM - 5 PM <br/>
Sat: 10 AM - 3 PM<br/>
Closed Sundays<br/>`;
  var dockHours = `<strong>Warehouse Dock Hours:</strong><br/> 
Monday - Friday <br/>
7:00 AM – 3:30 PM`;
  
$(".dockHoursHolder").html(dockHours);
$(".showroomHoursHolder").html(showroomHours);
$(".footer__block > .image-wrap").parent().html(
`<div class="footer__title">Visit us</div>
<ul class="footer__menu">
<li>7550 Roosevelt Rd<br/> 
Forest Park, IL 60130<br/><br/>`
+showroomHours+
`<br/> ` +
dockHours
+`</li>
</ul>`
);

  // scroll direction detection
  var lastScrollTop = 0;
  $(window).scroll(function(event){
     var st = $(this).scrollTop();
      //ScrollShowMenu(st < lastScrollTop);
      ScrollShowMenu(true);
     lastScrollTop = st;
  });

  
  // add "get started" link to all portfolio pages
  if ($(".cs-detailsbox").length == 1 && $(".cs-title").length == 1 && $(".cs-detailsbox").parent().find(".new-grid").length == 1){
      $(".cs-detailsbox").parent().find(".new-grid").append("<div class='cs-addedpadding'><a href='/pages/design-planning' class='cs-backbtn' style='margin-bottom: 25px;background-color:#e87724 !important;color:#ffffff !important;'>Get Started</a></div>");
      // adjust styling 
      $(".cs-detailsbox").parent().find(".new-grid .cs-addedpadding .cs-backbtn").css("margin","0px");
      $(".cs-detailsbox").parent().find(".new-grid .cs-addedpadding").css("padding","0px");
      $(".cs-detailsbox").parent().find(".new-grid .cs-addedpadding").css("padding-right","20px");
      $(".cs-detailsbox").parent().find(".new-grid .cs-addedpadding").css("padding-bottom","20px");
  }

  if (window.location.pathname == "/search"){
	  // hide/remove search boxes in header
		$(".header-item--search").css("visibility","hidden");
		$(".site-header__element.site-header__element--sub[data-type=search]").remove();
  }

  // remove aria labels from second and third search boxes
  //$(".search__input").eq(1).removeAttr("aria-label").removeAttr("aria-controls").removeAttr("aria-owns");
  //$(".search__input").eq(2).removeAttr("aria-label").removeAttr("aria-controls").removeAttr("aria-owns");
  $(".search__input").eq(1).attr("id", "Search2");
  $(".search__input").eq(2).attr("id", "Search3");


  // limit quantity by reservation
  if (jQuery("input[name='quantity']").length == 1){
  	// shopify doesn't allow event listeners on quantity field fsfr
  	setInterval(function () {
  		var realAvailable = (jQuery(".hvalStock").text()?parseInt(jQuery(".hvalStock").text()):0) - (jQuery(".hvalReserved").text()?parseInt(jQuery(".hvalReserved").text()):0);
  		var currentRequest = parseInt(jQuery("input[name='quantity']").val());
  		if (currentRequest > realAvailable) jQuery("input[name='quantity']").val(realAvailable);
  	}, 50);
  }
  
});

// hubspot form tracking
window.addEventListener('message', event => {
	if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
		console.log("Form Submitted! Event data: ${event.data}");
		console.log(event.data);
		if (gtag != null){
			// old, should be sufficient, sadly is not
			var formTitle = document.title.split('–')[0].trim();
			if (event.data.id == "8c6a9b0e-4679-49dd-95f6-0e5271b5001c")
				formTitle = "Newsletter";
			var sendStruct = {
				'event_name': 'hubspot_submission',
				'event_category': formTitle,
				'event_label': event.data.id
			};
			console.log(sendStruct);
			gtag( 'event', 'hubspot_submission',  sendStruct);
		}
		// new, hyper-specific (datalyer version)
		/*
		if (typeof dataLayer !== 'undefined') {
			// identify form and send the lead type separately
			var idList = [
				"b973e835-c0a5-446d-ba50-47b7eae19132",
				"e296dc38-a74e-46f4-a628-1771c3bc9773",
				"58fd4527-cb87-4b1c-858b-7a6432c3e311",
				"11e02cbf-61a8-4aa8-9b9c-09e91a00da36",
				"c60afa1f-4939-45fd-a919-a5c3b5ecf0c7",
				"bf6ca292-002c-492a-95c7-6c1bd82309fc",
				"0fc414e6-635b-4120-895c-9956e21b0d62",
				"84f9fac5-9c2c-42fd-93c3-b193fd027051",
				"8c6a9b0e-4679-49dd-95f6-0e5271b5001c"
			];
			var labelList = [
				"decommissioning-liquidation",
				"delivery-installation",
				"design-planning",
				"design-on-the-fly",
				"furniture-rental",
				"reupholstery",
				"services-overview",
				"contact-us",
				"newsletter"				
			];  
			var matchID = idList.indexOf(event.data.id);	
			if (matchID != -1){
				var tempLink = window.location.href;
				var tempCat = document.title;
				var leadStruct = {
					'event': "formsubmit_" + labelList[matchID]//,
					//'eventName': labelList[matchID],
					//'eventCategory': tempCat,
					//'eventAction': 'Form Submitted',
					//'eventLabel': tempLink
				};
				console.log(leadStruct);
				dataLayer.push(leadStruct);
			}
		}
		*/
		
		// new, hyper-specific (gtag version)
		if (gtag != null) {
			// identify form and send the lead type separately
			var idList = [
				"b973e835-c0a5-446d-ba50-47b7eae19132",
				"e296dc38-a74e-46f4-a628-1771c3bc9773",
				"58fd4527-cb87-4b1c-858b-7a6432c3e311",
				"11e02cbf-61a8-4aa8-9b9c-09e91a00da36",
				"c60afa1f-4939-45fd-a919-a5c3b5ecf0c7",
				"bf6ca292-002c-492a-95c7-6c1bd82309fc",
				"0fc414e6-635b-4120-895c-9956e21b0d62",
				"84f9fac5-9c2c-42fd-93c3-b193fd027051",
				"8c6a9b0e-4679-49dd-95f6-0e5271b5001c",
				"ed3e7a4b-b734-4ce1-b353-85a659125097",
				"eb863ccb-c1f6-46d3-9a8a-73ba0e90d05c",
				"808c6c37-b04b-414f-9a2d-de1eac32d8dd",
				"c026a6a4-944e-47f0-aafa-0f5f72174b59"
			];
			var labelList = [
				"decommissioning-liquidation",
				"delivery-installation",
				"design-planning",
				"design-on-the-fly",
				"furniture-rental",
				"reupholstery",
				"services-overview",
				"contact-us",
				"newsletter",
				"decommission-request",
				"contact-sales",
				"furniture-showroom",
				"careers"
			];  
			var matchID = idList.indexOf(event.data.id);	
			if (matchID != -1){
				var eventName = "formsubmit_" + labelList[matchID];
				var formTitle = document.title.split('–')[0].trim();
				var sendStruct = {
					'event_name': eventName,
					'event_category': formTitle,
					'event_label': event.data.id
				};
				console.log(sendStruct);
				gtag( 'event', eventName, sendStruct);
			}
		}
	}
});